import e from "./_curry1.mjs";
import t from "./_isArray.mjs";
import i from "./_isString.mjs";
var u = /* @__PURE__ */ e(function(r) {
  return t(r) ? !0 : !r || typeof r != "object" || i(r) ? !1 : r.length === 0 ? !0 : r.length > 0 ? r.hasOwnProperty(0) && r.hasOwnProperty(r.length - 1) : !1;
});
export {
  u as default
};
